import { render, staticRenderFns } from "./CompetitorReport.vue?vue&type=template&id=2339047a&scoped=true&"
import script from "./CompetitorReport.vue?vue&type=script&lang=ts&"
export * from "./CompetitorReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2339047a",
  null
  
)

export default component.exports